import React from 'react';
interface SectionProps {
  id?: string;
  eyebrow?: string;
  title?: React.ReactNode;
  intro?: React.ReactNode;
  tone?: 'white' | 'tint' | 'sand' | 'deep';
  width?: 'content' | 'narrow';
  children: React.ReactNode;
}
const toneClasses: Record<NonNullable<SectionProps['tone']>, string> = {
  white: 'bg-cream text-ink',
  tint: 'bg-canvas text-ink',
  sand: 'bg-sand text-ink',
  deep: 'bg-coal-900 text-white'
};
export function Section({
  id,
  eyebrow,
  title,
  intro,
  tone = 'white',
  width = 'content',
  children
}: SectionProps) {
  const hasHeader = Boolean(eyebrow || title || intro);
  const isDeep = tone === 'deep';
  return <section id={id} className={`w-full py-16 md:py-24 ${toneClasses[tone]}`} data-id="element-138" data-mp="2plk92rd4i8l">
      <div className={`mx-auto w-full px-5 md:px-8 ${width === 'narrow' ? 'max-w-narrow' : 'max-w-content'}`} data-id="element-139" data-mp="7nnaq8r4bju3">
        {hasHeader && <header className="mx-auto max-w-narrow text-center" data-id="element-140" data-mp="105iwq3db6j05">
            {eyebrow && <p className={`mb-4 font-sans text-xs font-bold uppercase tracking-[0.18em] ${isDeep ? 'text-forest-400' : 'text-forest-600'}`} data-id="element-141" data-mp="2zk29617snskq">
                {eyebrow}
              </p>}
            {title && <h2 className={`font-display text-[2rem] font-extrabold leading-[1.12] tracking-tight md:text-5xl ${isDeep ? 'text-white' : 'text-ink'}`} data-id="element-142" data-mp="33mf9ga3ruya4">
                {title}
              </h2>}
            {intro && <p className={`mx-auto mt-5 max-w-2xl text-lg md:text-xl ${isDeep ? 'text-white/70' : 'text-gray-500'}`} data-id="element-143" data-mp="3rc9pf0je12yl">
                {intro}
              </p>}
          </header>}
        <div className={hasHeader ? 'mt-12 md:mt-16' : ''} data-id="element-144" data-mp="1wzjtkd9gljok">{children}</div>
      </div>
    </section>;
}